import { IFactoringProfile, IPaymentSpeed } from "models/HaulPay";
import { IInviteInformation } from "models/User";
import { RootState } from "store";

export const selectUserDetails = (state: RootState) => state.userState.userDetails ?? {};
export const selectOnboardingInformation = (state: RootState): IInviteInformation =>
  state.userState.ICOnboardingInformation;
export const selectPaymentTerms = (state: RootState): IPaymentSpeed[] =>
  state.userState.paymentTerms;
export const selectFactoringProfile = (state: RootState): IFactoringProfile =>
  state.userState.factoringProfile;
